var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li',{staticClass:"link"},[_c('a',{attrs:{"href":""}})]),_c('li',{staticClass:"link"},[_c('a',{attrs:{"href":""}})]),_c('li',{staticClass:"link"},[_c('a',{attrs:{"href":""}})])])])
}]

export { render, staticRenderFns }